(() => {
  const initReviews = (section) => {
    if (!section || section.dataset.grrvReady) return;
    section.dataset.grrvReady = 'true';

    section.querySelectorAll('[data-grrv-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.grrvOpen || '');
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    section.querySelectorAll('[data-grrv-close]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = button.closest('dialog');
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    });

    section.querySelectorAll('dialog.grrv-dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
      });
    });

    const showAll = section.querySelector('[data-grrv-show-all]');
    showAll?.addEventListener('click', () => {
      section.querySelectorAll('[data-grrv-extra]').forEach((card) => card.hidden = false);
      showAll.hidden = true;
    });

    const writeLink = section.querySelector('[data-grrv-write]');
    const submitDetails = section.querySelector('.grrv-submit');
    writeLink?.addEventListener('click', () => {
      if (submitDetails) submitDetails.open = true;
    });
  };

  const init = () => document.querySelectorAll('[data-grrv]').forEach(initReviews);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
